export interface RecertificationModel {
  limitDate: string;
  remainingDays: number | string;
  status: RecertificationStatus;
}

export enum RecertificationStatusEnum {
  ATTESTED = "ATTESTED",
  PENDING = "PENDING",
  EXPIRED = "EXPIRED",
  MANDATORY = "MANDATORY",
}

export type RecertificationStatus =
  | "ATTESTED"
  | "PENDING"
  | "EXPIRED"
  | "MANDATORY";
